import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Photography = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my photography business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps photography businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for photography businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most photography businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my photography business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like photography. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Photography - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Photography CRM", url: "/industries/photography" }
  ];

  const industryData = {
    name: 'Photography',
    title: 'Book More Sessions & Automate Your Gallery Delivery',
    subtitle: 'Capture inquiries instantly, automate session reminders, and deliver galleries without manual uploads',
    icon: '📸',
    challenges: [
      'Missing inquiries while shooting',
      'Too much back-and-forth on session details',
      'Manual gallery uploads are time-consuming',
      'Hard to get clients to rebook',
      'Difficult to manage multiple session types'
    ],
    solutions: [
      'Instant inquiry capture with portfolio links',
      'Automated session detail collection',
      'Streamlined gallery delivery system',
      'Automated rebook campaigns',
      'Package and session type management'
    ],
    features: [
      'Client CRM with session history',
      'Online booking and packages',
      'Automated session reminders',
      'Contract and agreement automation',
      'Gallery delivery system',
      'Print ordering integration',
      'Seasonal marketing campaigns',
      'Review automation'
    ],
    results: [
      '70% of clients rebook',
      '50% more session bookings',
      '80% faster gallery delivery',
      '£4.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Photography UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for photography businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for photography UK, photography business software, photography customer management, photography lead generation UK"
        url="/industries/photography"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Photography;